export default __webpack_public_path__ + "static/media/Flag_of_Latvia.bc4d7dda.svg";